import CounterWidgetCard from './counter-widget-card'

export default CounterWidgetCard